import { QuesDataI } from "../EditQuiz";
import ChooseQuestionModal from "./ChooseQuestionModal";

const AddFromQuestionBank = ({
  questionNum,
  questionsImages,
  availableAnswers,
  setQuestionsImages,
  setAvailableAnswers,
  prefix,
  setAssessmentData,
}: {
  questionNum?: number;
  questionsImages?: { [key: string]: string };
  availableAnswers?: { [key: string]: number };
  setQuestionsImages?: React.Dispatch<
    React.SetStateAction<{ [key: string]: string }>
  >;
  setAvailableAnswers?: React.Dispatch<
    React.SetStateAction<{ [key: string]: number }>
  >;
  prefix?: string;
  setAssessmentData?: React.Dispatch<React.SetStateAction<QuesDataI>>;
}) => {
  const addQuestionNew = (question, questionNum) => {
    console.log({ question });
    setAssessmentData((prev) => ({
      ...prev,
      questions_data: prev.questions_data.map((q, idx) =>
        idx == questionNum
          ? {
              ...q,
              content: question.content,
              image_url: question.image_url,
              correct_answer: question.correct_answer,
              answers_count: question.answers_count,
              weight: question.weight,
            }
          : q
      ),
    }));
  };

  const addQuestion = (question, questionNum) => {
    const imgUrl = document.getElementById(
      `${prefix}question_img_url_${questionNum}`
    ) as HTMLInputElement;
    const qBody = document.getElementById(
      `${prefix}question_textarea_${questionNum}`
    ) as HTMLTextAreaElement;
    const ansCount = document.getElementById(
      `${prefix}question_ans_count_${questionNum}`
    ) as HTMLInputElement;
    const ans = document.getElementById(
      `${prefix}question_ans_${questionNum}`
    ) as HTMLInputElement;
    const weight = document.getElementById(
      `${prefix}question_weight_${questionNum}`
    ) as HTMLInputElement;
    const qID = document.getElementById(
      `qid_${questionNum}`
    ) as HTMLInputElement;
    console.log({ question });
    imgUrl.value = question.image_url;
    ansCount.value = question.answers_count;
    weight.value = question.weight;
    qID.value = question.id;
    qBody.value = question.content;

    setQuestionsImages({
      ...questionsImages,
      [`${prefix}question_img_url_${questionNum}`]: question.image_url,
    });
    setAvailableAnswers({
      ...availableAnswers,
      [`${prefix}question_ans_count_${questionNum}`]: question.answers_count,
    });
    setTimeout(() => {
      ans.value = question.correct_answer;
    }, 500);
  };

  return (
    <div className="my-2">
      <ChooseQuestionModal
        addQuestion={typeof setAssessmentData !== "undefined" ? addQuestionNew : addQuestion}
        questionNum={questionNum}
      />
    </div>
  );
};

export default AddFromQuestionBank;
